<template>
  <div class="bg-cart-gray flex-center py-3 text-xs font-niceone-medium gap-1">
    <span>{{ $t('cart.some') }}</span>
    <span @click="scrollIntoView" class="uppercase underline cursor-pointer">{{ $t('cart.out_of_stock') }}</span>
    <span>{{ $t('cart.product_in_bag') }}</span>
  </div>
</template>

<script setup>
import {useScrollToElement} from "@/composables/useScrollToElement";

const {scrollToElement} = useScrollToElement();
const scrollIntoView = () => {
  scrollToElement('out-of-stock-section');
};
</script>